import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconButtonContext = /*#__PURE__*/createContext(undefined);
export const IconButtonProvider = ({
  buttonStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(IconButtonContext.Provider, {
    value: {
      buttonStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `IconButton` component.
 * Note: The context is only available when the `IconButton` component is rendered as an ancestor.
 * @returns IconButtonContext - The context for the `IconButton` component.
 * @returns IconButtonContext.buttonStyleOverrides - CSS overrides to apply to the `Button` component.
 */
export const useIconButtonContext = () => {
  const iconButtonContext = useContext(IconButtonContext);
  return iconButtonContext;
};